import firebase from 'firebase'
var config = {
    apiKey: "AIzaSyBBGKQX8cjKIm1ilVBs9gfmoKqlUJfBPjU",
    authDomain: "muhazzib-uddin-farooqui.firebaseapp.com",
    databaseURL: "https://muhazzib-uddin-farooqui.firebaseio.com",
    projectId: "muhazzib-uddin-farooqui",
    storageBucket: "muhazzib-uddin-farooqui.appspot.com",
    messagingSenderId: "500904582331"
  };

  
export const fire = firebase.initializeApp(config);
export const database=fire.database().ref('/');


// WEBPACK FOOTER //
// ./src/fire.js